export const getters = {
  getAllElements: state => {
    let allElements = [];
    Object.entries(state.videos.default).forEach(element => {
      allElements.push({
        key: element[0],
        value: element[1],
        elementtype: "videos",
        lang: "default"
      });
    });
    Object.entries(state.videos.en).forEach(element => {
      allElements.push({
        key: element[0],
        value: element[1],
        elementtype: "videos",
        lang: "en"
      });
    });
    Object.entries(state.videos.de).forEach(element => {
      allElements.push({
        key: element[0],
        value: element[1],
        elementtype: "videos",
        lang: "de"
      });
    });
    Object.entries(state.pdfs.en).forEach(element => {
      allElements.push({
        key: element[0],
        value: element[1],
        elementtype: "pdfs",
        lang: "en"
      });
    });
    Object.entries(state.pdfs.de).forEach(element => {
      allElements.push({
        key: element[0],
        value: element[1],
        elementtype: "pdfs",
        lang: "de"
      });
    });
    return allElements;
  },
  getForCertainLanguage: state => language => {
    if (language) {
      return state.videos[language];
    }
    return state.videos.default;
  },
  getPdfsForCertainLanguage: state => language => {
    return state.pdfs[language];
  },
  isLanguageCached: state => language => {
    if (language === "en") {
      return state.enIsCached;
    } else {
      return state.deIsCached;
    }
  },
  getVideosInDifferentLanguages: state => languages => {
    let videosWithDifferentLanguage = [];
    languages.forEach(language => {
      let videosForOneLanguage = state.videos[language];
      Object.values(videosForOneLanguage).forEach(video => {
        videosWithDifferentLanguage.push(video);
      });
    });

    let videosForOneLanguage = state.videos.default;
    Object.values(videosForOneLanguage).forEach(video => {
      videosWithDifferentLanguage.push(video);
    });

    return videosWithDifferentLanguage;
  },

  getPdfsInDifferentLanguages: state => languages => {
    let pdfsWithDifferentLanguage = [];
    languages.forEach(language => {
      let pdfsForOneLanguage = state.pdfs[language];
      Object.values(pdfsForOneLanguage).forEach(pdf => {
        pdfsWithDifferentLanguage.push(pdf);
      });
    });

    return pdfsWithDifferentLanguage;
  }
};
